var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.loading)?_c('span',[_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_c('b',[_vm._v(_vm._s(_vm.formattedPrice(_vm.balance)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }